import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CtaButton } from '../CtaButton';
import { familiarItems } from '../../data/content';
export function SoundsFamiliar() {
  return <section className="w-full bg-blush px-4 py-14 sm:px-6 sm:py-20" aria-labelledby="familiar-title" data-id="element-282" data-mp="5iq0sjaqocvt">
      <div className="mx-auto max-w-5xl" data-id="element-283" data-mp="p3y9jyahpdq">
        <div id="familiar-title" data-id="element-284" data-mp="ff2vnki0sws5">
          <SectionHeading eyebrow="Does this sound familiar?" title="If you answered YES to any of these…" subtitle="5-MIN MENOPAUSE™ was built for you." data-id="element-285" data-mp="fe04dbgscsbp" />
        </div>

        <ul className="mt-9 grid gap-4 md:grid-cols-2" data-id="element-286" data-mp="ofhk2sqa6rzv">
          {familiarItems.map(item => <li key={item.text} className="flex gap-4 rounded-2xl border border-navy/10 bg-white p-5" data-id="element-287" data-mp="jhg26b4lcypz">
              <span className="text-2xl leading-none" aria-hidden="true" data-id="element-288" data-mp="2l8jbmx2qw78y">
                {item.emoji}
              </span>
              <p className="text-[14.5px] leading-snug text-navy/75 sm:text-[15.5px]" data-id="element-289" data-mp="1r942xzk1fjl8">
                {item.text}
              </p>
            </li>)}
        </ul>

        <div className="mt-10 rounded-3xl bg-navy p-6 sm:p-9" data-id="element-290" data-mp="216ihftmehyaw">
          <h3 className="font-display text-[24px] font-bold leading-tight text-white sm:text-3xl" data-id="element-291" data-mp="2145rouaeijna">
            It doesn’t have to be this way.
          </h3>
          <div className="mt-4 space-y-3 text-[15px] leading-relaxed text-white/75 sm:text-[16.5px]" data-id="element-292" data-mp="29zc44c46fzys">
            <p data-id="element-293" data-mp="2ewlzs9i5t7v2">The problem isn’t necessarily a lack of knowledge.</p>
            <p data-id="element-294" data-mp="2jwzxaxm4wzeu">
              The problem is that clinical information isn’t always organized for real-world
              decision-making.
            </p>
            <p data-id="element-295" data-mp="2ov1roep0gl5m">
              You may have access to excellent guidelines… but when you have to remember where a
              recommendation was buried while your patient is waiting, information becomes harder to
              use.
            </p>
          </div>

          <p className="mt-6 text-[12px] font-extrabold uppercase tracking-[0.12em] text-rose-light" data-id="element-296" data-mp="mgb18z6tc3zm">
            That’s why you need a method
          </p>
          <div className="mt-3 flex flex-wrap items-center gap-2 sm:gap-3" data-id="element-297" data-mp="hkdw7p102k25">
            {['Information', 'Process', 'Decision'].map((step, index) => <React.Fragment key={step} data-id="element-298" data-mp="rf5vcxa8dez1" data-mpi={index}>
                {index > 0 ? <ArrowRightIcon className="h-4 w-4 shrink-0 text-white/40" aria-hidden="true" data-id="element-299" data-mp="15fghjn0li5dv" /> : null}
                <span className="rounded-xl bg-white/10 px-3 py-2 font-display text-[15px] font-bold uppercase tracking-wide text-white sm:text-lg" data-id="element-300" data-mp="10fu3xcguun4j">
                  {step}
                </span>
              </React.Fragment>)}
          </div>
        </div>

        <div className="mx-auto mt-10 max-w-xl" data-id="element-301" data-mp="1o5y9vqhimyyp">
          <CtaButton label="Yes, show me the method" subtext="Instant digital access · Only $27 today" data-id="element-302" data-mp="1o6puk69krca7" />
        </div>
      </div>
    </section>;
}